<ul class="dashboard-nav-list">
  @for (item of items(); track item.label) {
    @if ('children' in item) {
      <ng-container [ngTemplateOutlet]="groupTemplate" [ngTemplateOutletContext]="{ $implicit: item }" />
    } @else {
      <ng-container [ngTemplateOutlet]="linkTemplate" [ngTemplateOutletContext]="{ $implicit: item }" />
    }
  }
</ul>

@if (hasBetaItem()) {
  <p class="beta-note">
    Beta features: feedback welcome at
    <a class="beta-note-link" [href]="'mailto:' + feedbackEmail" (click)="itemClick.emit($event)">{{
      feedbackEmail
    }}</a>
  </p>
}

<ng-template #groupTemplate let-group>
  <li class="group-header">{{ group.label }}</li>

  @for (child of group.children; track child.routerLink) {
    <ng-container [ngTemplateOutlet]="linkTemplate" [ngTemplateOutletContext]="{ $implicit: child }" />
  }
</ng-template>

<ng-template #linkTemplate let-link>
  <li class="list-item">
    <a
      atButton
      class="list-item-link"
      routerLinkActive="active"
      size="sm"
      variant="plain"
      [routerLink]="link.routerLink"
      [routerLinkActiveOptions]="{ exact: !!link.exact }"
      (click)="itemClick.emit($event)"
    >
      <at-icon>{{ link.icon }}</at-icon>
      <span class="list-item-text">
        {{ link.label }}
        @if (isBeta(link)) {
          <span class="nav-badge">Beta</span>
        }
      </span>
      @if (link.count && link.count() > 0) {
        <span class="nav-count sa-mono">
          <span aria-hidden="true">{{ link.count() }}</span>
          <span class="cdk-visually-hidden">{{ link.count() }} {{ link.countLabel }}</span>
        </span>
      }
    </a>
  </li>
</ng-template>
